var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fp" }, [
    _vm.schema.settings.ctaUrl
      ? _c(
          "a",
          {
            staticClass: "fp__main-image-content-container",
            attrs: { href: _vm.schema.settings.ctaUrl }
          },
          [
            _c(
              "split-wrapper",
              {
                attrs: {
                  imageWidthClass: _vm.schema.settings.imageWidth,
                  backgroundColorClass: _vm.schema.settings.backgroundColor,
                  textAlignmentClass: "text-center",
                  reversedClass: _vm.schema.settings.layout,
                  marginTop: _vm.schema.settings.marginTop,
                  marginBottom: _vm.schema.settings.marginBottom
                }
              },
              [
                _c("template", { slot: "image" }, [
                  _c("div", {
                    staticClass: "fp__image",
                    class: [_vm.schema.settings.layout],
                    style:
                      "background-image: url(" +
                      _vm.schema.settings.lifestyleImage +
                      ");"
                  })
                ]),
                _c("template", { slot: "content" }, [
                  _c(
                    "div",
                    { staticClass: "fp__main-wrap" },
                    [
                      _c("img", {
                        staticClass: "fp__product-image hidden-sm",
                        attrs: {
                          src:
                            _vm.schema.settings.productImageOverride ||
                            _vm.schema.settings.product.featured_image,
                          alt: _vm.schema.settings.product.title
                        }
                      }),
                      _c(
                        "h2",
                        {
                          staticClass: "fp__header",
                          class: [
                            _vm.schema.settings.imageWidth === "sw--50"
                              ? "h4"
                              : "h5",
                            _vm.schema.settings.productTitleColor
                          ]
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.schema.settings.productTitleOverride ||
                                _vm.schema.settings.product.title
                            )
                          )
                        ]
                      ),
                      _c("div", {
                        staticClass: "fp__body client-generated",
                        class: [_vm.schema.settings.productDescriptionColor],
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.schema.settings.productDescription ||
                              _vm.truncateHTML(
                                _vm.schema.settings.product.description,
                                134
                              )
                          )
                        }
                      }),
                      _vm.schema.settings.ctaText
                        ? _c(
                            /link/.test(_vm.schema.settings.ctaStyle)
                              ? "v-link"
                              : "v-button",
                            {
                              tag: "component",
                              class: _vm.schema.settings.ctaStyle
                            },
                            [_vm._v(_vm._s(_vm.schema.settings.ctaText))]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ],
              2
            )
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "fp__main-image-content-container" },
          [
            _c(
              "split-wrapper",
              {
                attrs: {
                  imageWidthClass: _vm.schema.settings.imageWidth,
                  backgroundColorClass: _vm.schema.settings.backgroundColor,
                  textAlignmentClass: "text-center",
                  reversedClass: _vm.schema.settings.layout,
                  marginTop: _vm.schema.settings.marginTop,
                  marginBottom: _vm.schema.settings.marginBottom
                }
              },
              [
                _c("template", { slot: "image" }, [
                  _c("div", {
                    staticClass: "fp__image",
                    class: [_vm.schema.settings.layout],
                    style:
                      "background-image: url(" +
                      _vm.schema.settings.lifestyleImage +
                      ");"
                  })
                ]),
                _c("template", { slot: "content" }, [
                  _c(
                    "div",
                    { staticClass: "fp__main-wrap" },
                    [
                      _c("img", {
                        staticClass: "fp__product-image hidden-sm",
                        attrs: {
                          src:
                            _vm.schema.settings.productImageOverride ||
                            _vm.schema.settings.product.featured_image,
                          alt: _vm.schema.settings.product.title
                        }
                      }),
                      _c(
                        "h2",
                        {
                          staticClass: "h3-mobile fp__header",
                          class: [
                            _vm.schema.settings.imageWidth === "sw--50"
                              ? "h4-tablet-up"
                              : "h5-tablet-up",
                            _vm.schema.settings.productTitleColor
                          ]
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.schema.settings.productTitleOverride ||
                                _vm.schema.settings.product.title
                            )
                          )
                        ]
                      ),
                      _c("div", {
                        staticClass: "fp__body body-md client-generated",
                        class: [_vm.schema.settings.productDescriptionColor],
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.schema.settings.productDescription ||
                              _vm.truncateHTML(
                                _vm.schema.settings.product.description,
                                134
                              )
                          )
                        }
                      }),
                      _vm.schema.settings.ctaText
                        ? _c(
                            /link/.test(_vm.schema.settings.ctaStyle)
                              ? "v-link"
                              : "v-button",
                            {
                              tag: "component",
                              class: _vm.schema.settings.ctaStyle
                            },
                            [_vm._v(_vm._s(_vm.schema.settings.ctaText))]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ],
              2
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }